import React from "react"
import { Link } from "gatsby"

import { useLocale } from "context/locale"

import IcoSales from "assets/icons/header-sales.svg"
import IcoHelp from "assets/icons/header-help.svg"
import IcoQueries from "assets/icons/header-queries.svg"

const ContactSubmenu = ({ onClick }) => {
  const { t } = useLocale()

  return (
    <div className="header__submenu">
      <Link to={t("/sales/")} onClick={onClick}>
        <span>
          <img src={IcoSales} alt="" />
        </span>
        {t("Sales")}
      </Link>
      <Link to={t("/help-support/")} onClick={onClick}>
        <span>
          <img src={IcoHelp} alt="" />
        </span>
        {t("Help & Support")}
      </Link>
      <Link to={t("/general-queries/")} onClick={onClick}>
        <span>
          <img src={IcoQueries} alt="" />
        </span>
        {t("General Queries")}
      </Link>
    </div>
  )
}

export default ContactSubmenu
